
import { defineComponent, getCurrentInstance, PropType } from 'vue';
import { PictureActionItemAppSetup } from './scripts/app';
import { PictureActionItemSeoSetup } from './scripts/seo';
import { PictureActionItemCommonSetup } from './scripts/common';
import { Picture } from '~/api/topic';

export default defineComponent({
    components: {},
    props: {
        index: {
            type: Number,
            default: 0,
        },
        picture: {
            type: Object as PropType<Picture>,
            default: () => ({}),
        },
        isLoginStatus: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const { proxy } = getCurrentInstance() || {};

        const commonSetupConfig = PictureActionItemCommonSetup(props);
        const setupConfig = proxy?.$isAppEnvironment ? PictureActionItemAppSetup(props) : PictureActionItemSeoSetup(props);

        return {
            formattedLikeCount: commonSetupConfig.formattedLikeCount,
            formattedCommentCount: commonSetupConfig.formattedCommentCount,
            formattedDownloadCount: commonSetupConfig.formattedDownloadCount,

            isLiked: setupConfig.isLiked,
            excuteLikeAction: setupConfig.excuteLikeAction,
            excuteCommentAction: setupConfig.excuteCommentAction,
            excuteDownloadAction: setupConfig.excuteDownloadAction,
        };
    },
});
